import React from 'react';

import style from './zone.module.scss';
const Zone = ({ children }) => (
  <div className={style['zone has-border'] + ' ' + style['has-background']}>
    {children}
  </div>
);
export default Zone;
